module.exports = __webpack_public_path__ + "img/course_007.705b5f0.webp";